import { render } from "./AdvertisingRight.vue?vue&type=template&id=ac35848e&scoped=true"
import script from "./AdvertisingRight.vue?vue&type=script&lang=js"
export * from "./AdvertisingRight.vue?vue&type=script&lang=js"

import "./AdvertisingRight.vue?vue&type=style&index=0&id=ac35848e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac35848e"]])

export default __exports__